import localStorage from 'localStorage'

export default function setCurrentRestaurantId (currentRestaurantId) {

	return localStorage.setItem('currentRestaurantId', currentRestaurantId)

}
